import { FraudReportState } from "@idw-types/state/fraud-report-state";
import { TimeRangeTypes } from "@enums/time-range-types";
import { FraudReportActionTypes, FraudReportActions } from "../actions/fraud-report-actions";
import { getTimeRange } from "@utils/date-util";

export const initialFraudReportState: FraudReportState = {
    referenceData: {
        isLoading: false,
        companies: null,
        relyingParties: null,
        rpServices: null,
        assertions: null,
        riskLevels: null
    },
    searchFilters: {
        companyId: null,
        rpServiceIds: [],
        relyingPartyIds: [],
        assertionIds: [],
        riskLevelIds: [],
        startDate: getTimeRange(TimeRangeTypes.CURRENT_MONTH).startDate,
        endDate: getTimeRange(TimeRangeTypes.CURRENT_MONTH).endDate,
        timeRangeType: TimeRangeTypes.CURRENT_MONTH
    },
    searchResults: {
        searchDate: null,
        isLoading: false,
        assertionFraudResults: null
    },
    fileExport: {
        isLoading: false
    }
};

export const fraudReportReducer = (
    state: FraudReportState = initialFraudReportState,
    action: FraudReportActions
): FraudReportState => {
    switch (action.type) {
        // Reference Data
        case FraudReportActionTypes.SET_FRAUD_REPORT_REFERENCE_DATA_LOADING:
            return {
                ...state,
                referenceData: {
                    ...(action.payload.isLoading
                        ? { ...initialFraudReportState.referenceData }
                        : { ...state.referenceData }),
                    isLoading: action.payload.isLoading
                }
            };
        case FraudReportActionTypes.SET_FRAUD_REPORT_REFERENCE_DATA:
            return {
                ...state,
                referenceData: {
                    ...action.payload.referenceData,
                    isLoading: false
                }
            };
        // Search
        case FraudReportActionTypes.SET_FRAUD_REPORT_SEARCH_FILTERS:
            return {
                ...state,
                searchFilters: {
                    ...action.payload.searchFilters
                }
            };
        case FraudReportActionTypes.SET_FRAUD_REPORT_SEARCH_RESULTS_LOADING:
            return {
                ...state,
                searchResults: {
                    ...(action.payload.isLoading
                        ? { ...initialFraudReportState.searchResults }
                        : { ...state.searchResults }),
                    isLoading: action.payload.isLoading
                }
            };
        case FraudReportActionTypes.SET_FRAUD_REPORT_SEARCH_RESULTS:
            return {
                ...state,
                searchResults: {
                    isLoading: false,
                    assertionFraudResults: action.payload.assertionFraudResults,
                    searchDate: new Date()
                }
            };
        // Export
        case FraudReportActionTypes.SET_FRAUD_REPORT_EXPORT_LOADING:
            return {
                ...state,
                fileExport: {
                    isLoading: action.payload.isLoading
                }
            };
        default:
            return state;
    }
};